import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 40px 1fr;
	align-items: flex-end;
	gap: 10px;
`;

const StyledIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
`;

const StyledTopContainer = styled.div`
	display: flex;
	justify-content: space-between;

	${TextLabel} {
		&:nth-child(1) {
			font-weight: 400;
			font-size: 14px;
			line-height: 16px;
			color: #ffffff;
			opacity: 0.5;
		}

		&:nth-child(2) {
			font-weight: 700;
			font-size: 14px;
			line-height: 16px;
			color: #ffffff;
		}
	}
`;

const StyledProgressWrapper = styled.div`
	width: 100%;
	height: 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	overflow: hidden;
`;

const StyledProgress = styled.div`
	height: 10px;
	border-radius: 10px;
`;

export {
	StyledContainer,
	StyledIconContainer,
	StyledInfoContainer,
	StyledTopContainer,
	StyledProgressWrapper,
	StyledProgress,
};
